module.exports = __webpack_public_path__ + "static/media/venderFrontImage.933b4887.png";